import React, { useEffect, createContext, useCallback, useState, useRef, useContext } from 'react';
import { useDispatch, useSelector, Provider } from 'react-redux';
import { createSlice, createAsyncThunk, createEntityAdapter, configureStore, combineReducers, createSelector } from '@reduxjs/toolkit';
import intl from 'react-intl-universal';
import { useQuery } from 'react-query';
import axios from 'axios';
import isEmpty from 'lodash-es/isEmpty';
import { isToday, parse } from 'date-fns';
import _styled from 'styled-components';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var getSession = function getSession(_ref) {
  var session = _ref.session;
  return session;
};

var initialState = '';
var session = /*#__PURE__*/createSlice({
  name: 'Session',
  initialState: initialState,
  reducers: {
    setSession: function setSession(_, _ref) {
      var payload = _ref.payload;
      return payload;
    }
  }
});
var setSession = session.actions.setSession;
var session$1 = session.reducer;

var SessionProvider = function SessionProvider(_ref) {
  var children = _ref.children,
      session = _ref.session;
  var dispatch = useDispatch();
  var isSessionInStore = useSelector(getSession);
  useEffect(function () {
    dispatch(setSession(session));
  }, [dispatch, session]);
  if (!isSessionInStore) return null;
  return React.createElement(React.Fragment, null, children);
};
var useSession = function useSession(name) {
  if (name === void 0) {
    name = 'X-ODDS-SESSION';
  }

  return document.cookie.split('; ').reduce(function (r, v) {
    var parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
};

var IsMobileContext = /*#__PURE__*/createContext(undefined);

var IsMobileProvider = function IsMobileProvider(_ref) {
  var children = _ref.children,
      isMobile = _ref.isMobile;
  return React.createElement(IsMobileContext.Provider, {
    value: isMobile
  }, children);
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var SESSION = 'X-ODDS-SESSION';
var http = /*#__PURE__*/axios.create({
  baseURL: "" + (process.env.NODE_ENV !== "production" ? 'https://test.betfan.pl/' : process.env.DOMAIN_URL)
});
var https = {
  get: function get(url, session, headers) {
    var _extends2;

    return http.get(url, {
      headers: _extends((_extends2 = {}, _extends2[SESSION] = session, _extends2), headers)
    });
  },
  post: function post(url, data, session) {
    var _headers;

    return http.post(url, data, {
      headers: (_headers = {}, _headers[SESSION] = session, _headers)
    });
  }
};

var getLocale = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(lang) {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", https.get("/static/lang2/" + lang + ".json", ''));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getLocale(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchDictionary = /*#__PURE__*/createAsyncThunk('Dictionary/FetchDictionary', /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(locale, _ref) {
    var rejectWithValue, _yield$getLocale, data;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rejectWithValue = _ref.rejectWithValue;
            _context.next = 3;
            return getLocale(locale);

          case 3:
            _yield$getLocale = _context.sent;
            data = _yield$getLocale.data;
            return _context.abrupt("return", data || rejectWithValue(null));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var dictionary = /*#__PURE__*/createSlice({
  name: 'Dictionary',
  initialState: {},
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchDictionary.fulfilled, function (_, _ref3) {
      var payload = _ref3.payload;
      return payload;
    });
  }
});
var dictionary$1 = dictionary.reducer;

var getDictionary = function getDictionary(_ref) {
  var dictionary = _ref.dictionary;
  return dictionary;
};

var queryOptions = {
  refetchOnWindowFocus: false
};

var LocaleProvider = function LocaleProvider(_ref) {
  var locale = _ref.locale,
      children = _ref.children;
  var dispatch = useDispatch();
  var dictionary = useSelector(getDictionary);
  var dictionaryFetcher = useCallback(function () {
    return dispatch(fetchDictionary(locale));
  }, [locale]);
  useQuery('locale', dictionaryFetcher, queryOptions);
  if (isEmpty(dictionary)) return null;
  intl.init({
    currentLocale: 'default',
    locales: {
      "default": dictionary
    }
  });
  return React.createElement(React.Fragment, null, children);
};

var getGamesList = function getGamesList(session) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(isMobile) {
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (isMobile === void 0) {
                isMobile = false;
              }

              return _context.abrupt("return", https.get("/rest/integration/onextwo/game_list?isMobile=" + isMobile, session));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getBetradarStream = function getBetradarStream(session) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(_ref4) {
      var streamId, streamType, device;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              streamId = _ref4.streamId, streamType = _ref4.streamType, device = _ref4.device;
              return _context3.abrupt("return", https.get("/rest/integrations/betradarLCO/" + streamId + "/" + streamType + "/" + device, session));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var gamesAdapter = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var game_id = _ref.game_id;
    return game_id;
  }
});
var fetchGames = /*#__PURE__*/createAsyncThunk('OnextwoGames/FetchGames', /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(isMobile, _ref2) {
    var getState, rejectWithValue, _yield$getGamesList, data;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getState = _ref2.getState, rejectWithValue = _ref2.rejectWithValue;
            _context.next = 3;
            return getGamesList(getState().session)(isMobile);

          case 3:
            _yield$getGamesList = _context.sent;
            data = _yield$getGamesList.data;
            return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(gamesAdapter.getInitialState()));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());
var games = /*#__PURE__*/createSlice({
  name: 'OnextwoGames',
  initialState: /*#__PURE__*/gamesAdapter.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchGames.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      var games = JSON.parse(payload);
      gamesAdapter.setAll(state, games);
    });
  }
});
var onextwo = games.reducer;

var getStreamsList = function getStreamsList(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", https.get("/rest/integrations/sis/get-streams", session));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
var getStream = function getStream(session) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(streamId) {
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", https.get("/rest/integrations/sis/get-stream-url/" + streamId, session));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var streamAdapter = /*#__PURE__*/createEntityAdapter({
  selectId: function selectId(_ref) {
    var streamId = _ref.streamId;
    return streamId;
  }
});
var fetchStreams = /*#__PURE__*/createAsyncThunk('SisStreams/FetchStreams', /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_, _ref2) {
    var getState, rejectWithValue, _yield$getStreamsList, data;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getState = _ref2.getState, rejectWithValue = _ref2.rejectWithValue;
            _context.next = 3;
            return getStreamsList(getState().session)();

          case 3:
            _yield$getStreamsList = _context.sent;
            data = _yield$getStreamsList.data;
            return _context.abrupt("return", (data == null ? void 0 : data.data) || rejectWithValue(streamAdapter.getInitialState()));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}());
var streams = /*#__PURE__*/createSlice({
  name: 'SisStreams',
  initialState: /*#__PURE__*/streamAdapter.getInitialState(),
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchStreams.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      streamAdapter.setAll(state, payload);
    });
  }
});
var sis = streams.reducer;

var reducer = /*#__PURE__*/combineReducers({
  session: session$1,
  dictionary: dictionary$1,
  onextwo: onextwo,
  sis: sis
});
var store = /*#__PURE__*/configureStore({
  reducer: reducer,
  devTools: {
    name: 'SB-integrations'
  }
});

var LOADING = "loading";
var IDLE = "idle";
var READY = "ready";
var ERROR = "error";
var LOAD = "load";

var useScript = function useScript(src, id) {
  var _useState = useState(src ? LOADING : IDLE),
      status = _useState[0],
      setStatus = _useState[1];

  useEffect(function () {
    if (!src) {
      setStatus(IDLE);
      return;
    }

    var script = document.querySelector("script[src=\"" + src + "\"]");

    if (!script) {
      script = document.createElement("script");
      script.id = id != null ? id : '';
      script.src = src;
      script.async = true;
      script.dataset.status = LOADING;
      document.body.appendChild(script);

      var setAttributeFromEvent = function setAttributeFromEvent(event) {
        if (!script) return;
        script.dataset.status = (event == null ? void 0 : event.type) === LOAD ? READY : ERROR;
      };

      script.addEventListener(LOAD, setAttributeFromEvent);
      script.addEventListener(ERROR, setAttributeFromEvent);
    } else {
      script.dataset.status && setStatus(script.dataset.status);
    }

    var setStateFromEvent = function setStateFromEvent(event) {
      setStatus((event == null ? void 0 : event.type) === LOAD ? READY : ERROR);
    };

    script.addEventListener(LOAD, setStateFromEvent);
    script.addEventListener(ERROR, setStateFromEvent);
    return function () {
      if (script) {
        script.removeEventListener(LOAD, setStateFromEvent);
        script.removeEventListener(ERROR, setStateFromEvent);
      }
    };
  }, [src]);
  return status;
};

var _streamAdapter$getSel = /*#__PURE__*/streamAdapter.getSelectors(function (_ref) {
  var sis = _ref.sis;
  return sis;
}),
    selectAll = _streamAdapter$getSel.selectAll;

var FORMAT = 'yyyy-MM-dd HH:mm:ss';
var getCurrentStream = /*#__PURE__*/createSelector(selectAll, function (streams) {
  return streams.filter(function (_ref2) {
    var startDate = _ref2.startDate;
    return isToday(parse(startDate, FORMAT, new Date()));
  })[0];
});

var Wrapper = /*#__PURE__*/_styled.main.withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "aiuaoc-0"
})([""]);
var Video = /*#__PURE__*/_styled.video.withConfig({
  displayName: "indexstyled__Video",
  componentId: "aiuaoc-1"
})(["width:100%;"]);

var VIDEO_SCRIPT = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
var queryOptions$1 = {
  refetchOnWindowFocus: false
};

var Stream = function Stream() {
  var _useState = useState(undefined),
      streamURL = _useState[0],
      setStreamURL = _useState[1];

  var session = useSelector(function (_ref) {
    var session = _ref.session;
    return session;
  });
  var ref = useRef(null);
  var dispatch = useDispatch();
  var scriptStatus = useScript(VIDEO_SCRIPT);
  var streamsFetcher = useCallback(function () {
    return dispatch(fetchStreams());
  }, []);
  useQuery('sisStreams', streamsFetcher, queryOptions$1);
  var stream = useSelector(getCurrentStream); // Fetch video source

  useEffect(function () {
    var fetchStream = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref2) {
        var streamId, _yield$getStream, data;

        return runtime_1.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                streamId = _ref2.streamId;
                _context.next = 3;
                return getStream(session)(streamId);

              case 3:
                _yield$getStream = _context.sent;
                data = _yield$getStream.data;
                setStreamURL(data == null ? void 0 : data.data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchStream(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    if (!stream) return;
    fetchStream(stream);
  }, [stream, session, setStreamURL]); // Set up player (non-default)

  useEffect(function () {
    if (scriptStatus !== READY) return;
    if (!streamURL) return; // Keep the Hls instance in the window object
    // due to unpredictable nature of Spike implementation

    window['hls'] = new Hls();

    if (Hls.isSupported()) {
      window['hls'].loadSource(streamURL);
      window['hls'].attachMedia(ref.current);
      window['hls'].on(Hls.Events.MANIFEST_PARSED, function () {
        var _ref$current;

        (_ref$current = ref.current) == null ? void 0 : _ref$current.play();
      });
    } else {
      var _ref$current2;

      if (typeof ((_ref$current2 = ref.current) == null ? void 0 : _ref$current2.src) !== 'string') return;
      ref.current.src = streamURL;
    }

    return function () {
      var _window$hls;

      (_window$hls = window['hls']) == null ? void 0 : _window$hls.destroy();
      window['hls'] = null;
    };
  }, [scriptStatus, ref.current, streamURL]);
  return React.createElement(Wrapper, null, React.createElement(Video, {
    ref: ref,
    controls: true,
    playsInline: true,
    muted: true,
    autoPlay: true
  }));
};

var liveChannelOnlineContext = /*#__PURE__*/createContext(undefined);

var LiveChannelOnlineProvider = function LiveChannelOnlineProvider(_ref) {
  var streamId = _ref.streamId,
      streamType = _ref.streamType,
      device = _ref.device,
      scriptURL = _ref.scriptURL,
      stylesheetURL = _ref.stylesheetURL,
      allowFullScreen = _ref.allowFullScreen,
      restrictions = _ref.restrictions,
      children = _ref.children;

  var _useState = useState({
    streamId: streamId,
    streamType: streamType,
    device: device,
    scriptURL: scriptURL,
    stylesheetURL: stylesheetURL,
    allowFullScreen: allowFullScreen,
    restrictions: restrictions
  }),
      state = _useState[0];

  return React.createElement(liveChannelOnlineContext.Provider, {
    value: state
  }, children);
};

var useLiveChannelOnlineContext = function useLiveChannelOnlineContext() {
  var context = useContext(liveChannelOnlineContext);

  if (context === undefined) {
    throw new Error("'useLiveChannelOnlineContext' must be used within a LiveChannelOnlineProvider");
  }

  return context;
};

var useLiveChannelOnline = function useLiveChannelOnline() {
  return useLiveChannelOnlineContext();
};

var getCustomerData = function getCustomerData(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", https.get("/rest/customer/session/customerData/false", session));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var getPlacedBet = function getPlacedBet(session) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", https.get("/rest/transaction/transactions/customerHasBetPlacedWithin/1/all", session, {
              'request-language': 'PL'
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var useCheck = function useCheck(condition, performCheck) {
  var _useState = useState(false),
      isConditionMet = _useState[0],
      setIsConditionMet = _useState[1];

  useEffect(function () {
    var check = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
        var isConditionMet;
        return runtime_1.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return performCheck();

              case 2:
                isConditionMet = _context.sent;
                setIsConditionMet(isConditionMet);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function check() {
        return _ref.apply(this, arguments);
      };
    }();

    if (!condition) {
      setIsConditionMet(true);
    }

    check();
  }, [condition, performCheck]);
  return isConditionMet;
};

var Video$1 = /*#__PURE__*/_styled.video.withConfig({
  displayName: "indexstyled__Video",
  componentId: "sc-1nvrurt-0"
})(["width:100%;"]);

var VIDEO_SCRIPT$1 = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
var queryOptions$2 = {
  refetchOnWindowFocus: false
};

var Stream$1 = function Stream() {
  var _useState = useState(undefined),
      streamURL = _useState[0],
      setStreamURL = _useState[1];

  var session = useSelector(function (_ref) {
    var session = _ref.session;
    return session;
  });
  var ref = useRef(null);
  var checkIsUserLoggedIn = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    var _data$data;

    var _yield$getCustomerDat, data;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getCustomerData(session)();

          case 2:
            _yield$getCustomerDat = _context.sent;
            data = _yield$getCustomerDat.data;
            return _context.abrupt("return", !!(data == null ? void 0 : (_data$data = data.data) == null ? void 0 : _data$data.userId));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [session]);
  var checkIsBalancePositive = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
    var _data$data2;

    var _yield$getCustomerDat2, data;

    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getCustomerData(session)();

          case 2:
            _yield$getCustomerDat2 = _context2.sent;
            data = _yield$getCustomerDat2.data;
            return _context2.abrupt("return", !!(data == null ? void 0 : (_data$data2 = data.data) == null ? void 0 : _data$data2.balance));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [session]);
  var checkHasUserPlacedBetWithinADay = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
    var _yield$getPlacedBet, data;

    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getPlacedBet(session)();

          case 2:
            _yield$getPlacedBet = _context3.sent;
            data = _yield$getPlacedBet.data;
            return _context3.abrupt("return", data == null ? void 0 : data.data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [session]);

  var _useLiveChannelOnline = useLiveChannelOnline(),
      streamId = _useLiveChannelOnline.streamId,
      streamType = _useLiveChannelOnline.streamType,
      device = _useLiveChannelOnline.device,
      restrictions = _useLiveChannelOnline.restrictions;

  var isLoggedIn = useCheck(restrictions.isLogged, checkIsUserLoggedIn);
  var isBalancePositive = useCheck(restrictions.isBalancePositive, checkIsBalancePositive);
  var hasUserPlacedBetWithinADay = useCheck(restrictions.hasBetPlacedWithinADay, checkHasUserPlacedBetWithinADay);
  var scriptStatus = useScript(VIDEO_SCRIPT$1);
  var fetchStreamUrl = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4() {
    var _yield$getBetradarStr, data;

    return runtime_1.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getBetradarStream(session)({
              streamId: streamId,
              streamType: streamType,
              device: device
            });

          case 2:
            _yield$getBetradarStr = _context4.sent;
            data = _yield$getBetradarStr.data;
            setStreamURL(data == null ? void 0 : data.data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [session, streamId, streamType, device]);
  useEffect(function () {
    if (scriptStatus !== READY) return;
    if (!(isLoggedIn && isBalancePositive && hasUserPlacedBetWithinADay)) return;
    if (!streamURL) return; // Keep the Hls instance in the window object
    // due to unpredictable nature of Spike implementation

    window['hls'] = new Hls();

    if (Hls.isSupported()) {
      window['hls'].loadSource(streamURL);
      window['hls'].attachMedia(ref.current);
      window['hls'].on(Hls.Events.MANIFEST_PARSED, function () {
        var _ref$current;

        (_ref$current = ref.current) == null ? void 0 : _ref$current.play();
      });
    } else {
      var _ref$current2;

      if (typeof ((_ref$current2 = ref.current) == null ? void 0 : _ref$current2.src) !== 'string') return;
      ref.current.src = streamURL;
    }

    return function () {
      var _window$hls;

      (_window$hls = window['hls']) == null ? void 0 : _window$hls.destroy();
      window['hls'] = null;
    };
  }, [scriptStatus, ref.current, streamURL]);
  useQuery('liveChannelOnline', fetchStreamUrl, _extends({}, queryOptions$2));
  if (!isLoggedIn) return React.createElement(React.Fragment, null, React.createElement("p", null, intl.get('integration_betradarLCO_notLoggedIn')));
  if (!isBalancePositive) return React.createElement(React.Fragment, null, React.createElement("p", null, intl.get('integration_betradarLCO_negativeBalance')));
  if (!hasUserPlacedBetWithinADay) return React.createElement(React.Fragment, null, React.createElement("p", null, intl.get('integration_betradarLCO_noBetPlaced')));
  return React.createElement(Video$1, {
    ref: ref,
    controls: true,
    playsInline: true,
    muted: true,
    autoPlay: true
  });
};

var SisStreams = function SisStreams(_ref) {
  var session = _ref.session,
      lang = _ref.lang;
  return React.createElement(Provider, {
    store: store
  }, React.createElement(SessionProvider, {
    session: session
  }, React.createElement(LocaleProvider, {
    locale: lang
  }, React.createElement(Stream, null))));
};

var BetradarLiveChannelOnline = function BetradarLiveChannelOnline(_ref2) {
  var session = _ref2.session,
      lang = _ref2.lang,
      isMobile = _ref2.isMobile,
      stream = _objectWithoutPropertiesLoose(_ref2, ["session", "lang", "isMobile"]);

  return React.createElement(Provider, {
    store: store
  }, React.createElement(SessionProvider, {
    session: session
  }, React.createElement(LocaleProvider, {
    locale: lang
  }, React.createElement(IsMobileProvider, {
    isMobile: isMobile
  }, React.createElement(LiveChannelOnlineProvider, Object.assign({}, stream), React.createElement(Stream$1, null))))));
};

var SBIntegrations = {
  useSession: useSession,
  BetradarLiveChannelOnline: BetradarLiveChannelOnline,
  SisStreams: SisStreams
};

export { SBIntegrations };
//# sourceMappingURL=sb-integrations.esm.js.map
